import { useTranslation } from 'react-i18next'
import DashboardTabLayout from '@/components/dashboard/DashboardTabLayout'

export default function BrandingHub() {
  const { t } = useTranslation('dashboard')

  return (
    <DashboardTabLayout
      title={t('hubs.branding.title')}
      subtitle={t('hubs.branding.subtitle')}
      tabs={[
        {
          id: 'appearance',
          label: t('hubs.branding.tabs.appearance'),
          to: '/dashboard/branding/appearance',
        },
        {
          id: 'visibility',
          label: t('hubs.branding.tabs.visibility'),
          to: '/dashboard/branding/visibility',
        },
        {
          id: 'qrcode',
          label: t('hubs.branding.tabs.qrcode'),
          to: '/dashboard/branding/qrcode',
        },
      ]}
    />
  )
}
